export default class ScenarioResponseMapper {
  map(response: any) {
    return response;
  }

  unMap(response: any) {
    return response;
  }
}
